import { Component, OnInit, EventEmitter, Input, Output, AfterViewInit, ViewChild } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';
import { PaymentService } from 'src/app/services/payment.service';

import { NotePaymentHistoryDetailsListItem } from 'src/app/models/payment';

@Component({
  selector: 'app-note-payment-history-details-list',
  templateUrl: './note-payment-history-details-list.component.html',
  styleUrls: ['./note-payment-history-details-list.component.scss']
})
export class NotePaymentHistoryDetailsListComponent implements OnInit, AfterViewInit {
  private _participantId = null;
  private _noteId = null;

  @Input()
  set participantId(participantId: number) {
    this._participantId = participantId || null;
    this.getData();
  }
  get participantId(): number {
    return this._participantId;
  }

  @Input()
  set noteId(noteId: number) {
    this._noteId = noteId || null;
    this.getData();
  }
  get noteId(): number {
    return this._noteId;
  }

  @Output() dataReturned = new EventEmitter<NotePaymentHistoryDetailsListItem[]>();

  // Have to use the following ElementDisplayStyle variables and ngStyle to show/hide table elements
  // This because the table paginator will not attach correctly otherwise - this is a work around for a known issue
  private _hideElementDisplayStyle = 'none';
  private _showElementDisplayStyle = 'inline';
  private _showElementDisplayStyleIE = 'inline-block';

  private _handleError: HandleError;
  private _logging = environment.logging;

  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  showSpinner = false;

  notePaymentHistoryDetailsList: NotePaymentHistoryDetailsListItem[] = [];

  // DataTable
  tableDisplayedColumns = [
    'paymentDate',
    'paymentId',
    'paymentAmount',
    'principalAmountApplied',
    'interestAmountApplied',
    'feeAmount',
    'paymentType'
  ];
  tableDataSource = new MatTableDataSource<NotePaymentHistoryDetailsListItem>(this.notePaymentHistoryDetailsList);
  tableDisplayStyle: string = this._hideElementDisplayStyle;
  tableDisplayStyleIE: string = this._hideElementDisplayStyle;
  notePaymentHistoryDetailsListFound = false;

  constructor(private _errorHandler: ErrorHandler, private _paymentService: PaymentService, public media: MediaObserver) {
    this._handleError = _errorHandler.createHandleError('NotePaymentHistoryDetailsListComponent');
  }

  ngOnInit() {
    this.notePaymentHistoryDetailsListFound = true;
    this.tableDisplayStyle = this.notePaymentHistoryDetailsListFound ? this._showElementDisplayStyle : this._hideElementDisplayStyle;
    this.tableDisplayStyleIE = this.notePaymentHistoryDetailsListFound ? this._showElementDisplayStyleIE : this._hideElementDisplayStyle;
  }

  ngAfterViewInit() {}

  getData(): void {
    if (this._noteId !== null) {
      this.showSpinner = true;
      this.getNotePaymentHistoryDetailsList(this._noteId);
    }
  }

  getNotePaymentHistoryDetailsList(noteId: number): void {
    this.showSpinner = true;
    this._paymentService.getNotePaymentHistoryDetailsList(noteId).subscribe(
      resultArray => {
        this.notePaymentHistoryDetailsList = resultArray;
        if (this._logging.serviceCallTraceLog) {
          console.log('NotePaymentHistoryDetailsListComponent.getNotePaymentHistoryDetailsList :: result.length = ' + resultArray.length);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('NotePaymentHistoryDetailsListComponent.getNotePaymentHistoryDetailsList :: result = ' + JSON.stringify(resultArray));
        }
        this.tableDataSource = new MatTableDataSource<NotePaymentHistoryDetailsListItem>(this.notePaymentHistoryDetailsList);
        this.notePaymentHistoryDetailsListFound = resultArray.length > 0;
        this.tableDisplayStyle = this.notePaymentHistoryDetailsListFound ? this._showElementDisplayStyle : this._hideElementDisplayStyle;
        this.tableDisplayStyleIE = this.notePaymentHistoryDetailsListFound
          ? this._showElementDisplayStyleIE
          : this._hideElementDisplayStyle;
        this.dataReturned.emit(this.notePaymentHistoryDetailsList);
        this.getDataComplete();
      },
      error => this._handleError('getNotePaymentHistoryDetailsList', error)
    );
  }

  getDataComplete(): void {
    this.showSpinner = false;
  }
}
